import { render, staticRenderFns } from "./AssignAssessorModal.vue?vue&type=template&id=38bcac1e&"
import script from "./AssignAssessorModal.vue?vue&type=script&lang=js&"
export * from "./AssignAssessorModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignAssessorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports